import { addDoc, updateDoc } from "firebase/firestore";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  couponsCollectionRef,
  getCouponsDoc,
  uploadImgCoupon,
} from "../utils/firestoreHelpers";
import { formatDate } from "../utils/helpers";

const initialData = {
  title: "",
  link: "",
  description: "",
  code: "",
  tnc: "",
  date_from: formatDate(new Date()),
  date_to: formatDate(new Date()),
  date: formatDate(new Date()),
};

const initialErrorData = {
  title: "",
  link: "",
  description: "",
  code: "",
  tnc: "",
  date_from: "",
  date_to: "",
  date: "",
  img: "",
};

const EditCoupons = ({ onClose, prevData, dialogType }) => {
  // final String link;
  // final String title;
  // final String description;
  // final String code;
  // final String tnc;
  const [data, setData] = useState(
    prevData
      ? {
          ...prevData,
          date: formatDate(prevData.date),
          date_from: formatDate(prevData.date_from),
          date_to: formatDate(prevData.date_to),
        }
      : { ...initialData }
  );
  // console.log({ data });
  const [img, setImg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ ...initialErrorData });

  const validate = () => {
    const { title, link, description, code, tnc, date, date_from, date_to } =
      data;
    let isValid = true;
    let tempError = { ...initialErrorData };
    if (!title) {
      isValid = false;
      tempError["title"] = "Title is required";
    }
    if (!link) {
      isValid = false;
      tempError["link"] = "Link is required";
    }
    if (!description) {
      isValid = false;
      tempError["description"] = "Description is required";
    }
    if (!code) {
      isValid = false;
      tempError["code"] = "Code is required";
    }
    if (!tnc) {
      isValid = false;
      tempError["tnc"] = "Terms and Conditions is required";
    }
    if (!date) {
      isValid = false;
      tempError["date"] = "Date is required";
    }
    if (!date_from) {
      isValid = false;
      tempError["date_from"] = "Date From is required";
    }
    if (!date_to) {
      isValid = false;
      tempError["date_to"] = "Date To is required";
    }
    // if (!img && !prevData?.image_url) {
    //   isValid = false;
    //   tempError["img"] = "Image  is required";
    // }
     //  Image
    if (!img && !prevData?.image_url) {
      isValid = false;
      tempError.img = "Image is required";
    } else if (img) {
      const validTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!validTypes.includes(img.type)) {
        isValid = false;
        tempError.img = "Only PNG, JPG, JPEG images are allowed";
      }
    }

    setError(tempError);
    return isValid;
  };

  const onSubmit = async () => {
    // console.log("data :: ", data);
    let isValid = validate();
    // console.log("isValid :: " + isValid);
    // return;
    if (!isValid) return;
    setLoading(true);
    try {
      const { title, link, description, code, tnc, date, date_from, date_to } =
        data;
      if (prevData) {
        let imageUrl = prevData?.image_url;
        const bussinessDoc = getCouponsDoc(prevData.id);
        if (img) {
          imageUrl = await uploadImgCoupon(img);
        }
        const newFields = {
          title,
          link,
          description,
          code,
          tnc,
          image_url: imageUrl,
          date: new Date(date),
          date_from: new Date(date_from),
          date_to: new Date(date_to),
        };
        await updateDoc(bussinessDoc, newFields);
      } else {
        if (!img) return;
        const imageUrl = await uploadImgCoupon(img);
        const payload = {
          title,
          link,
          description,
          code,
          tnc,
          image_url: imageUrl,
          date: new Date(date),
          date_from: new Date(date_from),
          date_to: new Date(date_to),
        };
        await addDoc(couponsCollectionRef, payload);
      }
      onClose();
    } catch (e) {
      console.log("error", e);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => {
    let value = e.target.value;
    const name = e.target.name;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const [fileSizeError, setFileSizeError] = useState("");
  const fileSizeLimit = 1 * 1024 * 1024; // 1 MB limit

  const checkFileSize = (event) => {
    const fileInput = event.target;

    if (fileInput.files.length > 0 && fileInput.files[0].size > fileSizeLimit) {
      setFileSizeError("File size exceeds the 1 mb limit.");
      fileInput.value = ""; // Clear the input
    } else {
      setImg(event.target.files[0]);
      setFileSizeError("");
    }
  };

  return (
    <form>
      <Modal show={true} onHide={() => {}}>
        <Modal.Header>
          <Modal.Title>{`${dialogType} Content`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label htmlFor="title" className="form-label d-block">
              Title *
            </label>
            <input
              value={data.title}
              onChange={onChange}
              className="w-100 form-control"
              name="title"
              required
            />
            <p className="text-danger small">{error.title}</p>
          </div>
          <div className="mb-3">
            <label htmlFor="description" className="form-label d-block">
              Description *
            </label>
            <input
              value={data.description}
              onChange={onChange}
              className="w-100 form-control"
              name="description"
              required
            />
            <p className="text-danger small">{error.description}</p>
          </div>
          <div className="mb-3">
            <label htmlFor="code" className="form-label d-block">
              Coupon Code *
            </label>
            <input
              value={data.code}
              onChange={onChange}
              className="w-100 form-control"
              name="code"
              required
            />
            <p className="text-danger small">{error.code}</p>
          </div>
          <div className="mb-3">
            <label htmlFor="link" className="form-label d-block">
              Link *
            </label>
            <input
              value={data.link}
              onChange={onChange}
              className="w-100 form-control"
              name="link"
              required
            />
            <p className="text-danger small">{error.link}</p>
          </div>
          <div className="mb-3">
            <label htmlFor="tnc" className="form-label d-block">
              Terms & conditions *
            </label>
            <textarea
              value={data.tnc}
              onChange={onChange}
              className="w-100 form-control"
              name="tnc"
              required
            />
            <p className="text-danger small">{error.tnc}</p>
          </div>

          {/* <div className="mb-3">
            <label htmlFor="date" className="form-label d-block">
              Date
            </label>
            <input
              type="date"
              className="w-100 form-control"
              name="date"
              value={data.date}
              onChange={onChange}
              required
            />
            <p className="text-danger small">{error.date}</p>
          </div> */}
            <div className="d-flex gap-2">
            <div className="mb-3 flex-fill">
              <label htmlFor="date_from" className="form-label d-block">
                Date From / Event Date *
              </label>
              <input
                type="date"
                className="w-100 form-control"
                name="date_from"
                value={data.date_from}
                onChange={onChange}
                required
                min={new Date().toISOString().split("T")[0]}
              />
              <p className="text-danger small">{error.date_from}</p>
            </div>

            <div className="mb-3 flex-fill">
              <label htmlFor="date_to" className="form-label d-block">
                Date To
              </label>
              <input
                type="date"
                className="w-100 form-control"
                name="date_to"
                value={data.date_to}
                onChange={onChange}
                required
                min={data.date_from || new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="image" className="form-label d-block">
              Image *
            </label>
            <input
              type="file"
              className="w-100 form-control"
              name="image"
              // onChange={(e) => setImg(e.target.files[0])}
              onChange={checkFileSize}
              required={!!prevData}
              accept="image/png, image/jpeg, image/jpg"
            />
            <p className="text-danger small mt-1">{fileSizeError}</p>
            <p className="text-danger small">{error.img}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={onSubmit} disabled={loading}>
            {loading ? (
              <>
                <span
                  class="spinner-grow spinner-grow-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default EditCoupons;
